import React from "react";
import styles from "./styles.module.scss";
import ModalLayout from "../ModalLayout/ModalLayout";
import NoResults from "../NoResults";
import { ApplyTemplateListProps } from "app/components/Button/ApplyTemplateDropdown/index.types";
import SearchBar from "app/components/inputs/SearchBar";
import { Dots } from "app/components/Loading";
import { useTranslation } from 'react-i18next';
import ButtonVariant from "app/components/Button/ButtonVariant";

const ApplyTemplateListsModal = ({
  isOpen,
  onClose,
  hasNoResult,
  noResultImage,
  noResultTitle,
  noResultSubText,
  modalSubTitle,
  searchPlaceholder,
  onSearchChange,
  pending,
  children,
  cancelHandler,
  applyHandler,
}: ApplyTemplateListProps) => {
  const { t } = useTranslation();

  return (
    <ModalLayout isOpen={isOpen} onClose={onClose}>
      <div className={styles.container}>
        {/* <div className={classNames(styles.overlay)} onClick={onClose} /> */}
        <div className={styles.headingWrapper}>
          <h1>{t("Apply Template")}</h1>
          {modalSubTitle && <p>{modalSubTitle}</p>}
          <SearchBar
            placeholder={searchPlaceholder}
            onChange={onSearchChange}
            className={styles.searchInput}
          />
        </div>
        {pending && !hasNoResult ? (
          <div className={styles.space_list_container}>
            <Dots active={true} />
          </div>
        ) : hasNoResult ? (
          <NoResults
            image={noResultImage}
            text={noResultTitle}
            subtext={noResultSubText}
          />
        ) : (
          children
        )}
        <div className={styles.buttons}>
          <ButtonVariant
            title={t("Cancel")}
            buttonType="secondary-outline"
            onClickFunc={cancelHandler}
          />
          <ButtonVariant
            title={t("Apply")}
            buttonType="primary"
            onClickFunc={applyHandler}
            disabled={hasNoResult}
          />
        </div>
      </div>
    </ModalLayout>
  );
};

export default ApplyTemplateListsModal;
